// theme.guard.ts
import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ThemeService } from '../services/theme.service';

export function themeGuard(theme: 'legacy' | 'primeng'): CanActivateFn {
  return () => {
    inject(ThemeService).apply(theme);
    return true;
  };
}
